module.exports = __webpack_public_path__ + "static/media/7.4286b197.jpg";